import { render, staticRenderFns } from "./ScheduleCopy.vue?vue&type=template&id=5bed8084&"
import script from "./ScheduleCopy.vue?vue&type=script&lang=js&"
export * from "./ScheduleCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports